import { useAccount } from '../contexts/AccountContext';
import axios from 'axios';

export const useApiCall = () => {
  const { account } = useAccount();

  return async (endpoint, method = 'GET', data = null, cancelToken = null) => {
    const API_BASE_URL = process.env.REACT_APP_API_URL;
    const API_KEY = process.env.REACT_APP_API_KEY;

    const url = `${API_BASE_URL}${endpoint}`;
    const headers = {
      'Content-Type': 'application/json',
      'api': API_KEY,
      ...(account?.token && { auth: account.token }),
    };

    const options = {
      method: method.toUpperCase(),
      url,
      headers,
      ...(data && { data }),
      ...(cancelToken && { signal: cancelToken.signal }),
      timeout: 20000,
    };

    return axios(options)
      .then(res => res.data)
      .catch(error => {
        if (error.name === 'AbortError' || error.code === 'ERR_CANCELED') return null;
        return {
          error: true,
          type: error.response?.status || 'network',
          message: error.response?.data?.message || error.message || 'Network error',
        };
      });
  };
};
